import { Link } from "react-router-dom";

// سطر موافقة واحد: مربع تأشير صريح + عنوان + شرح + رابط المستند الكامل.
export const ConsentRow = ({ id, checked, onChange, label, hint, to, linkLabel }) => (
  <label
    className="neu-in flex cursor-pointer items-start gap-3 rounded-2xl p-4 transition-colors hover:bg-muted/20"
    data-testid={`consent-row-${id}`}
  >
    <input
      type="checkbox"
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      data-testid={`consent-check-${id}`}
      className="mt-1 h-6 w-6 shrink-0 accent-primary"
    />
    <span className="text-sm leading-6 text-muted-foreground">
      <span className="mb-1 block text-base font-bold text-foreground">{label}</span>
      {hint}{" "}
      <Link to={to} target="_blank" className="font-bold text-primary hover:brightness-125" data-testid={`consent-link-${id}`}>
        {linkLabel}
      </Link>
    </span>
  </label>
);
